import { formatDisplayTime } from "./dateFormat";

export const STATUS_CONFIG = {
  FULL: { color: "#4caf50", label: "Available", short: "YES", bg: "#e8f5e9" },
  ABSENT: { color: "#f44336", label: "Not Available", short: "OFF", bg: "#ffebee" },
  LIMITED: { color: "#2196f3", label: "Limited", short: "LIM", bg: "#e3f2fd" },
  PARTIAL: { color: "#9c27b0", label: "Partially Available", short: "PART", bg: "#f3e5f5" },
  HALF_AM: { color: "#ff9800", label: "Half Day (AM)", short: "AM", bg: "#fff3e0" },
  HALF_PM: { color: "#ff9800", label: "Half Day (PM)", short: "PM", bg: "#fff3e0" },
  CUSTOM: { color: "#607d8b", label: "Custom Hours", short: "HRS", bg: "#eceff1" },
};

export const STATUS_OPTIONS = Object.entries(STATUS_CONFIG).map(([value, cfg]) => ({
  value,
  ...cfg,
}));

/** Statuses where optional from/to hours can be specified */
export const STATUSES_WITH_HOURS = ["FULL", "ABSENT", "PARTIAL", "LIMITED", "CUSTOM"];

export const getStatusConfig = status => STATUS_CONFIG[status] || STATUS_CONFIG.ABSENT;

export const getHoursFieldLabels = status => {
  if (status === "ABSENT") {
    return {
      from: "Away from",
      to: "Away until",
      section: "Hours away (optional)",
    };
  }
  return {
    from: "Available from",
    to: "Available until",
    section: "Hours available (optional)",
  };
};

const normalizeTime = time => {
  if (!time) return null;
  const value = formatDisplayTime(time);
  return value === "00:00" ? null : value;
};

export const formatCellTimeRange = (timeFrom, timeTo) => {
  const from = normalizeTime(timeFrom);
  const to = normalizeTime(timeTo);
  if (!from || !to) return null;
  return `${from}-${to}`;
};

export const getCellLabel = cell => {
  if (!cell?.eStatus) return "";
  const cfg = getStatusConfig(cell.eStatus);
  const timeRange = formatCellTimeRange(cell.time_from, cell.time_to);
  if (timeRange) {
    if (cell.eStatus === "CUSTOM") return timeRange;
    return `${cfg.short} ${timeRange}`;
  }
  return cfg.short;
};
